module.exports = __webpack_public_path__ + "img/horizontal_3_2_pp2_9016.807fd387.png";